module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-popup', {
    attrs: {
      "id": "service1"
    },
    on: {
      "popup:open": _vm.setPopup,
      "popup:close": _vm.resetPopup
    }
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "New MoneyRoad",
      "closePopup": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('f7-list', {
    attrs: {
      "form": "",
      "id": "paymentsForm"
    }
  }, [_c('f7-list-item', {
    staticClass: "titleForm"
  }, [_c('div', [_vm._v("Debtor Information")]), _vm._v(" "), _c('f7-icon', {
    attrs: {
      "id": "bookContacts",
      "f7": "book"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-label', [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Debtor Name")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "id": "debtor-name",
      "name": "debtorName",
      "placeholder": "Debtor name",
      "type": "text"
    },
    model: {
      value: (_vm.debtorName),
      callback: function($$v) {
        _vm.debtorName = $$v
      },
      expression: "debtorName"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-label', {
    attrs: {
      "id": "debitorAccount"
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Debitor Account")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "id": "debtor-bank",
      "name": "debtorBankAccount",
      "placeholder": "Debtor bank",
      "type": "text"
    },
    model: {
      value: (_vm.debtorBank),
      callback: function($$v) {
        _vm.debtorBank = $$v
      },
      expression: "debtorBank"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-label', [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Debtor Email")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "id": "debtor-email",
      "name": "debtorEmail",
      "placeholder": "Debtor email",
      "type": "email"
    },
    model: {
      value: (_vm.debtorEmail),
      callback: function($$v) {
        _vm.debtorEmail = $$v
      },
      expression: "debtorEmail"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', {
    staticClass: "titleForm"
  }, [_c('div', [_vm._v("Creditor Infomation")])]), _vm._v(" "), _c('f7-list-item', [_c('f7-label', {
    attrs: {
      "id": "creditorAccount"
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Creditor Account")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "creditorBankAccount",
      "id": "account-input",
      "type": "text",
      "placeholder": "Creditor bank"
    },
    on: {
      "click": _vm.accountPicker
    },
    model: {
      value: (_vm.creditorBankName),
      callback: function($$v) {
        _vm.creditorBankName = $$v
      },
      expression: "creditorBankName"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', {
    staticClass: "titleForm"
  }, [_c('div', [_vm._v("Global Infomation")])]), _vm._v(" "), _c('f7-list-item', [_c('f7-label', [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Remittance")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "remittanceInformation",
      "placeholder": "Remittance information",
      "type": "text"
    },
    model: {
      value: (_vm.remittanceInformation),
      callback: function($$v) {
        _vm.remittanceInformation = $$v
      },
      expression: "remittanceInformation"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "id": "execDate"
    }
  }, [_c('f7-label', [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Execution Date")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "executionDate",
      "placeholder": "1900-12-12",
      "type": "date"
    },
    model: {
      value: (_vm.executionDate),
      callback: function($$v) {
        _vm.executionDate = $$v
      },
      expression: "executionDate"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-label', [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Amount (€)")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "amount",
      "placeholder": "Amount",
      "type": "number"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "checkbox": "",
      "name": "ImmPmtAccepted",
      "value": "0",
      "checked": _vm.ImmPmtAccepted,
      "title": "Debitor allowed to pay immediatelly"
    },
    on: {
      "click": function($event) {
        _vm.ImmPmtAccepted = !_vm.ImmPmtAccepted
      }
    }
  }), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "checkbox": "",
      "name": "modificationAccepted",
      "value": "0",
      "checked": _vm.modificationAccepted,
      "title": "Debitor allowed to modify payments"
    },
    on: {
      "click": function($event) {
        _vm.modificationAccepted = !_vm.modificationAccepted
      }
    }
  }), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "id": "switchItem"
    }
  }, [_c('f7-input', {
    attrs: {
      "id": "switch-input",
      "name": "fileSwitch",
      "type": "switch",
      "checked": _vm.fromCloud
    },
    on: {
      "change": _vm.switched
    }
  }), _vm._v(" "), _c('f7-label', [_vm._v("Attachment from Local/Cloud")])], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-label', [_vm._v("Reference")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "reference",
      "placeholder": "Reference",
      "type": "text"
    },
    model: {
      value: (_vm.attachementReference),
      callback: function($$v) {
        _vm.attachementReference = $$v
      },
      expression: "attachementReference"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "attachmentInputs"
    }
  }, [(!_vm.fromCloud) ? _c('f7-list-item', [_c('input', {
    staticClass: "inputfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Local Attachement")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "filename",
      "placeholder": _vm.attachementName,
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.attachementName),
      callback: function($$v) {
        _vm.attachementName = $$v
      },
      expression: "attachementName"
    }
  })], 1) : _c('f7-list-item', {
    on: {
      "click": _vm.filesPicker
    }
  }, [_c('f7-label', {
    attrs: {
      "id": "cloud-label"
    }
  }, [_vm._v("Cloud")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "cloudFile",
      "type": "text",
      "placeholder": _vm.attachementName,
      "id": "cloud-file-input",
      "readonly": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('f7-list', [_c('f7-button', {
    staticClass: "blueConfirmationButton",
    attrs: {
      "icon-f7": "compose",
      "color": "white"
    },
    on: {
      "click": _vm.sendPayments
    }
  }, [_vm._v("Send")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c6c4e264", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6c4e264","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/services/payments/CMPayments.vue
// module id = 2441
// module chunks = 2